<form [formGroup]="form">
    <div class="p-fluid formgrid grid">
        <hvl-form-item class="col-2" key="date" *ngIf="showDate"
                       label="{{ 'hrPerPosition.date' | translate }}" [showAsterisk]="true">
            <p-calendar [required]="true" name="beginDate" formControlName="date" [showIcon]="true"
                        #date appendTo="body" dateFormat="dd.mm.yy"></p-calendar>
        </hvl-form-item>
        <hvl-form-item class="col-2" key="objectCode"
                       label="{{ 'hrPerPosition.positionCode' | translate }}">
            <input formControlName="objectCode" id="objectCode" name="objectCode" pInputText
                   type="text"/>
        </hvl-form-item>
        <hvl-form-item class="col-2" key="position"
                       label="{{ 'hrPerPosition.position' | translate }}">
            <input formControlName="position" id="position" name="position" pInputText type="text"/>
        </hvl-form-item>
        <hvl-form-item class="col-2 pt-5">
            <p-checkbox
                id="managerialPosition"
                binary="true"
                formControlName="managerialPosition"
                name="managerialPosition"
                value="managerialPosition"
                label="{{ 'hrPosStaticInfo.managerPosition' | translate }}"
            ></p-checkbox>
        </hvl-form-item>
    </div>
</form>
